export enum KidnapAndExtortionSubscriptionOptions {
  AutoRenewal = 'autoRenewal',
}
